import {Label} from '@ytsaurus/components';

export type {LabelTheme} from '@ytsaurus/components';
export default Label;
